import carrito from './carrito';
import errorNotebook from './errorNotebook';
import { createStore } from 'vuex';

const store = createStore({
  modules: {
    carrito,
    errorNotebook,
  },
});

export default store;